module.exports = __webpack_public_path__ + "static/media/image_3.625977d1.jpg";